// /* eslint no-console: 0 */
import 'css/application.css'
import Vue from 'vue/dist/vue.common'
import dashboardChart from  '../components/dashboard/chart'
import dashboardApiKey from '../components/dashboard/api-key'
import billingAddCard from '../components/billing/add-card'
import Navbar from '../components/navbar'
import CodeSamples from '../components/home/code-samples'
import ServiceInfo from '../components/home/service-info'
import PricingCalculator from '../components/home/pricing-calculator'

document.addEventListener('DOMContentLoaded', () => {
  window.VM = new Vue({
    el: '#vue',
    components: {
      'dashboard-chart': dashboardChart,
      'dashboard-key': dashboardApiKey,
      'billing-add-card': billingAddCard,
      Navbar,
      CodeSamples,
      ServiceInfo,
      PricingCalculator,
    }
  })
})




// WEBPACK FOOTER //
// ./app/javascript/packs/application.js